<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true">
        <el-form-item label="交易日期">
          <date-range-picker :value="inputTime" @getChange="value => inputTime = value"
            :clearable="false" :maxRange="31" :disabledAfter="new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`).getTime() - 1000"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户号">
          <el-input v-model.trim="searchForm.merchantId" placeholder="请输入商户号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model.trim="searchForm.orderId" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="补贴状态">
          <el-select v-model="searchForm.subsidyStatus" class="form-input" clearable>
            <el-option v-for="item in subsidyList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行">
          <el-select v-model="searchForm.cardBank" class="form-input" clearable>
            <el-option value label="全部"></el-option>
            <el-option v-for="item in bankList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="searchLoading" @click="searchBtnClick">查询</el-button>
          <el-button type="primary" icon="el-icon-download" :loading="exportLoading" @click="exportBtnClick">导出</el-button>
        </el-form-item>
      </el-form>
    </module-card>
    <module-card title="银行补贴数据">
      <p style="margin-bottom: 20px;">补贴金额（元）：{{ countSubsidyAmount }}</p>
      <el-table border :data="tableData" v-loading="searchLoading">
        <el-table-column v-for="item in columns" :label="item.label" :prop="item.key" :key="item.key"></el-table-column>
      </el-table>
      <pagination :count="total" :edit-size="true" :page-no="pageNo" :size="pageSize"
        @changePage="value => { pageNo = value; getTableList() }"
        @changeSize="value => { pageSize = value; pageNo = 1; getTableList() }"></pagination>
    </module-card>
  </div>
</template>

<script>
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { formateDate, downJumpConfirm } from '@/assets/js/utils'
export default {
  name: 'bankSubsidyData',
  components: { dateRangePicker, pagination },

  data () {
    return {
      inputTime: [],
      searchForm: {
        cardBank: '',
        merchantId: '',
        orderId: '',
        subsidyStatus: '',
        startTime: '',
        endTime: ''
      },
      subsidyList: [
        { value: '', text: '全部' },
        { value: 0, text: '处理中' },
        { value: 1, text: '补贴' },
        { value: 2, text: '不补贴' }
      ],
      bankList: [],
      columns: [
        { label: '交易日期', key: 'tradeTime' },
        { label: '银行', key: 'cardBank' },
        { label: '商户号', key: 'merchantId' },
        { label: '订单号', key: 'orderId' },
        { label: '交易金额（元）', key: 'amount' },
        { label: '实收金额（元）', key: 'settleAmount' },
        { label: '补贴金额', key: 'subsidyAmount' },
        { label: '补贴日期', key: 'subsidyDate' },
        { label: '补贴费率', key: 'subsidyRate' },
        { label: '补贴状态', key: 'subsidyStatus' },
        { label: '补贴描述', key: 'subsidyMsg' },
        { label: '补贴流水号', key: 'subsidyOrder' },
        { label: '附加费补贴金额', key: 'extraSubsidyAmount' }
      ],
      countSubsidyAmount: '',
      searchLoading: false,
      exportLoading: false,
      tableData: [{ activityName: 1 }],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {},

  mounted () {
    const endTime = formateDate(new Date(new Date().getTime() - 3600 * 1000 * 24)).substring(0, 10) + ' 23:59:59'
    const startTime = formateDate(new Date(new Date().getTime() - 3600 * 1000 * 24)).substring(0, 10) + ' 00:00:00'
    this.inputTime = [startTime, endTime]
    this.searchBtnClick()
    this.getBankList()
  },

  methods: {
    searchBtnClick () {
      this.pageNo = 1
      this.getTableList()
    },
    getBankList () {
      this.$axios.post(this.$api.getSubsidyBankList, {}).then(res => {
        if (res.respCode === '0') {
          this.bankList = res.data?.map(item => ({ text: item, value: item })) || []
        }
      })
    },
    getTableList () {
      const params = {
        ...this.searchForm,
        startTime: this.inputTime && this.inputTime.length ? this.inputTime[0] : '',
        endTime: this.inputTime && this.inputTime.length ? this.inputTime[1] : '',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.tableData = []
      this.total = 0
      this.searchLoading = true
      this.$axios.post(this.$api.queryBankSubsidyList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.tableData = res.data.list
          this.total = res.data.count
          this.countSubsidyAmount = res.data.countSubsidyAmount
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    exportBtnClick () {
      const params = {
        ...this.searchForm,
        startTime: this.inputTime && this.inputTime.length ? this.inputTime[0] : '',
        endTime: this.inputTime && this.inputTime.length ? this.inputTime[1] : ''
      }
      this.exportLoading = true
      this.$axios.post(this.$api.exportBankSubsidyList, params).then(res => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    }
  }
}
</script>
<style lang='css' scoped></style>
